import App from "./App.vue";
window.mercadoPagoCheckout = function(id,settings){
    return new window.Vue({
      render: h => h(App, {
        props: {
          mode:settings.mode,
          singleQuote:settings.singleQuote,
          formLabels:settings.formLabels||{},
          publicKey:settings.publicKey,
          business:settings.business, 
          purchase:settings.purchase, 
          buyer:settings.buyer
        }
      })
    }).$mount(id);
}
export default App;
